import React from 'react';

const PageSection = ({ children }) => (
  <div className="page-section">{children}</div>
);

export default PageSection;
